import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { useParams } from 'react-router-dom'; // Added Meta Tag npm Package
import {   
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
    Label,
    Button,
    Form,
    Input,
    CardTitle,
    InputGroup, } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS3, formatDate, yearsPast } from "../../helpers/backend_helper"
import { EXIT_INTERVIEWS, EXIT_INTERVIEW4APPROVAL, DELETE_EXIT_INTERVIEW} from 'helpers/url_helper';
import * as url from "../../helpers/url_helper"

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';

    const ExitInterviewDetails = () => {
        const {id} = useParams();
        const [CompanyID, setCompanyID] = useState("")
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [state, setState] = useState({});

        const [customchkSuccess, setcustomchkSuccess] = useState(false);
        const [higherpay, sethigherpay] = useState(false);
        const [improvedworklifebalance, setimprovedworklifebalance] = useState(false);
        const [conflictwithotherstaff, setconflictwithotherstaff] = useState(false);
        const [jobinsecurity, setjobinsecurity] = useState(true);
        const [betterbenefits, setbetterbenefits] = useState(true);
        const [relocationmigration, setrelocationmigration] = useState(true);
        const [conflictwithmanagers, setconflictwithmanagers] = useState(true);
        const [furtherstudies, setfurtherstudies] = useState(true);
        const [bettercareeropportunities, setbettercareeropportunities] = useState(true);
        const [closertohome, setclosertohome] = useState(true);
        const [familypersonalreasons, setfamilypersonalreasons] = useState(true);

        const [jobImprovementObservations, setjobImprovementObservations] = useState('')
        const [policyImprovementObservations, setpolicyImprovementObservations] = useState('')
        const [additionalComments, setAdditionalComments] = useState('')
        const [potentialreturn, setpotentialreturn] = useState('')
        const [pleasantexperience, setpleasantexperience] = useState('')
        const [jobdissatisfaction, setjobdissatisfaction] = useState('')
        
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [departmentcode, setDepartmentCode] = useState('')

        const [RStatus, setRStatus] = useState("")
        const [date, setDate] = useState("")
        const [dateWhenStarted, setDatewhenStarted] = useState("")
        const [hrNo, setHrNo] = useState("")
        const [hrManager, setHrManager] = useState("")
        const [dateOfLastWorking, setDateofLastWorking] = useState("")
        const [address, setAddress] = useState('')
        
        const [etag, setEtag] = useState('')
        const [no, setNo] = useState('')

        toastr.options = TOAST_OPTIONS3;

        const handleDeleteExitInterview = () => {
            const data = {
                "no": no
            }
            axios.post(DELETE_EXIT_INTERVIEW, JSON.stringify(data), HRConfig)
                .then((r) =>{
                    console.log(r);
                }).catch((e) => {
                    console.log(e);
                })
        }
        const handleSendInterviewForApproval = () => {
            const data = {
                "no": no
            }
            axios.post(EXIT_INTERVIEW4APPROVAL, JSON.stringify(data), HRConfig)
                .then((r) =>{
                    console.log(r);
                }).catch((e) => {
                    console.log(e);
                })
        }
        const updateaddress = (e) => {
            if ((e.target.value != '')){
                let req = {}
                req = {
                    address  : e.target.value
                }
                toastr.info("Saving...")
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.EXIT_INTERVIEWS}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                    .then(function(response){     
                        if(response.status == '200'){
                            toastr.success("Saved" ); 
                        }else{
                            toastr.error("Could not save Address for further correspondencies" )
                        }
                        setIsloading(false)
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setIsloading(false)
                    }
                )
            }
        }

        const updateLastWorkingDate = (e) => {
            if (RStatus != "Open"){
                toastr.error("You cannot edit Exit Interviews that have already been submitted to HR!");
            } else {
                let newexprecdate = (e)
                if ((e != '')){
                    let req = {}
                    req = {
                        dateOfLastWorking  : e
                    }
                    toastr.info("Saving...")
                    const Config = {
                        auth: {
                            username: url.HRMIS,
                            password: url.HRMISPASS,
                        },
                        headers: {
                            'Content-Type': 'application/json',
                            'If-Match'    : '*'
                        }
                    }
                    axios.patch(`${url.EXIT_INTERVIEWS}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                        .then(function(response){     
                            if(response.status == '200'){
                                toastr.success("Saved" );
                                setDateofLastWorking(newexprecdate) 
                            }else{
                                toastr.error("Could not save last working Date!" )
                            }
                            setIsloading(false)
                        })
                        .catch(function (error) {
                            toastr.error(error.response.data.error.message);
                            setIsloading(false)
                        }
                    )
                }
            }
        }
        const handleUpdateInterview = (e) => {
            const interviewDate = formatDate(Date.now())
            const durationOfService = document.getElementsByClassName('durationOfService')[0].value
            const reasonForLeaving = document.getElementsByClassName('reasonForLeaving')[0].value
            const informedOfRestrictions = document.getElementsByClassName('informedOfRestrictions')[0].value

            const Q1 = document.getElementsByClassName('11')[0].value
            const Q2 = document.getElementsByClassName('12')[0].value
            const Q3 = document.getElementsByClassName('13')[0].value
            const Q4 = document.getElementsByClassName('14')[0].value
            const Q5 = document.getElementsByClassName('15')[0].value
            const Q6 = document.getElementsByClassName('16')[0].value
            const Q7 = document.getElementsByClassName('17')[0].value
            const Q8 = document.getElementsByClassName('18')[0].value
            const Q9 = document.getElementsByClassName('19')[0].value
            const Q10 = document.getElementsByClassName('110')[0].value
            const Q11 = document.getElementsByClassName('111')[0].value
            const Q12 = document.getElementsByClassName('112')[0].value
            const Q13 = document.getElementsByClassName('113')[0].value
            const Q14 = document.getElementsByClassName('114')[0].value
            const Q15 = document.getElementsByClassName('115')[0].value

            const exitData = {
                'higherPay'                  : interviewDate,
                'workLifeImprovement'            : empNo,
                'conflictWithOthers'     : durationOfService,
                'jobInsecurity'    : Q1,
                'betterBenefit'    : Q2,
                'migration'   : Q3,
                'conflictWithManagers'       : Q4, 
                'furtherStudies' : Q5,
                'betterCareer'        : Q6,
                'closerhome' : Q7,
                'familyReasons'   : Q8,
                'otherSpecify' : Q9,
                'objective2'     : Q10,
                'objective3'         : Q11,
                'objective4'     : Q12,
                'objective5' : Q13,
                'objective6'           : Q14,
                'additionalComment'   : Q15,
                
            }

            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : etag
                }
              }
              //console.log(JSON.stringify(Config))
            axios.patch(`${EXIT_INTERVIEWS}(${id})`, JSON.stringify(exitData), Config)
                .then(function(response){     
                    console.log(response); 
                    if(response.data.No){
                        toastr.success("Exit Interview Updated" ); 
                        //history.push('/exit-interview-submitted') 
                        getData();
                    }else{
                        toastr.success("Could not Submit" )

                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                // always executed
                
            });
        }

        const getData = () => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(url.EXIT_INTERVIEWS + "("+ id +")?$expand=exitLines"+ "&company="+ obj.activeCompany, HRConfig)
                .then(function(response){
                    setNo(response.data.no)
                    setRStatus(response.data.status)
                    setEtag(response.data['@odata.etag'])
                    setEmpNo(response.data.employeeNo);
                    setEmpName(response.data.employeeName);
                    setEmpTitle(response.data.positionName);
                    setDepartmentCode(response.data.departmentcode)
                    setDatewhenStarted(response.data.dateWhenStarted)
                    setDateofLastWorking(response.data.dateOfLastWorking)
                    setAddress(response.data.address)
                    setHrNo(response.data.hrNo)
                    setHrManager(response.data.hrManager)
                    setDate(response.data.date)
                    sethigherpay(response.data.higherPay)
                    setimprovedworklifebalance(response.data.workLifeImprovement)
                    setconflictwithotherstaff(response.data.conflictWithOthers)
                    setjobinsecurity(response.data.jobInsecurity)
                    setbetterbenefits(response.data.betterBenefit)
                    setrelocationmigration(response.data.migration)
                    setconflictwithmanagers(response.data.conflictWithManagers)
                    setfurtherstudies(response.data.furtherStudies)
                    setbettercareeropportunities(response.data.betterCareer)
                    setclosertohome(response.data.closerhome)
                    setfamilypersonalreasons(response.data.familyReasons)
                    setjobImprovementObservations(response.data.objective2)
                    setpolicyImprovementObservations(response.data.objective3)
                    setjobdissatisfaction(response.data.objective4)
                    setpotentialreturn(response.data.objective5)
                    setpleasantexperience(response.data.objective6)
                    setAdditionalComments(response.data.additionalComment)
                    
                    
                    setIsloading(false)

                    axios.get(`${url.EMPLOYEES2}?$filter=No eq '${response.data.employeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{
                        setEmpTitle(r.data.value[0].JobTitle);
                        setDepartmentCode(r.data.value[0].Department_Code)
                        const dc = setDepartmentCode(r.data.value[0].Department_Code);                   
                        setUserError(false);
                        }).catch((e)=>{ 
                            console.log(e); 
                            setIsloading(false) 
                })
            }).catch(function (error) {
                toastr.error(error.response.data.message);
                console.log(error);
                setIsloading(false)
            })
            .then(function () {
            // always executed
            
        });
        }
        useEffect(() => {
            getData();
            return () => {
                setState({}); 
              };
        },[]);

        return (
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Exit Interview Details | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Exit Interview" />
                        <div>
                            {userError && ( 
                            <Alert color="danger" role="alert">
                                Details Not Found in Dynamics 365 Business Central
                            </Alert>
                            )}
                            <Row>
                                <Col xl={4}>
                                    <Card>
                                        <CardBody>
                                            <CardTitle>Employee Details</CardTitle>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <th scope="col"> Number</th>
                                                                <td scope="col"> {empNo} </td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col"> Name</th>
                                                                <td scope="col">{empName}</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Position</th>
                                                                <td scope="col">{empTitle}</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Department</th>
                                                                <td scope="col">{departmentcode}</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Status</th>
                                                                <td scope="col">{RStatus}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>                                                      
                                        </CardBody>
                                    </Card>
                                    <div className="d-flex">
                                        <div className="flex-grow-1 ms-1">                                 
                                            <ul className="list-unstyled vstack gap-2 mb-0">
                                                <div className="d-grid gap-2">
                                                    {(RStatus == 'Open') && (
                                                    <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleDeleteExitInterview}>
                                                        <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                            Submit Exit Interview 
                                                    </Button>
                                                    )}
                                                    {(RStatus == 'Open') && (
                                                        <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDelete()}} >
                                                            <i className="mdi mdi-delete"/>{" "}
                                                                Delete Exit Interview
                                                        </Button>
                                                    )}
                                                    {(RStatus == 'Pending Approval') && (
                                                    <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleDeleteExitInterview}>
                                                        <i className="mdi mdi-book-cancel-outline"/>{" "}
                                                            Recall submitted Exit Interview
                                                    </Button>
                                                    )}
                                                </div>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col  xl={8}>
                                    <Card>
                                        <CardBody>
                                            <CardTitle>General</CardTitle>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <th scope="col"> Interview Number</th>
                                                                <td scope="col"> {no} </td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">HR Manager Number</th>
                                                                <td scope="col">{hrNo}</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col"> HR Manager Name</th>
                                                                <td scope="col"> {hrManager} </td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col"> Date of Initiation</th>
                                                                <td scope="col">
                                                                    {<Flatpickr
                                                                        value={date}
                                                                        disabled = {true}
                                                                        options={{
                                                                            altInput: true,
                                                                            altFormat: "F j, Y",
                                                                            dateFormat: "Y-m-d"
                                                                        }}
                                                                    />}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Employment Date</th>
                                                                <td scope="col">
                                                                    {<Flatpickr
                                                                        value={dateWhenStarted}
                                                                        disabled = {true}
                                                                        options={{
                                                                            altInput: true,
                                                                            altFormat: "F j, Y",
                                                                            dateFormat: "Y-m-d"
                                                                        }}
                                                                    />}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Last Working Date</th>
                                                                <td scope="col">
                                                                    {<Flatpickr
                                                                        value={dateOfLastWorking}
                                                                        onChange={(e)=>updateLastWorkingDate(formatDate(e))}
                                                                        options={{
                                                                            altInput: true,
                                                                            altFormat: "F j, Y",
                                                                            dateFormat: "Y-m-d"
                                                                        }}
                                                                    />}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Contact for further Correspondencies</th>
                                                                <td scope="col">
                                                                <p className="text-muted fs-14 mb-0">
                                                                    <input 
                                                                        className="form-control" 
                                                                        type="text" 
                                                                        value={address} 
                                                                        onChange={(e)=>setAddress(e.target.value)}
                                                                        onBlur={updateaddress}
                                                                        disabled={(RStatus=='Open')?false:true}
                                                                />
                                                            </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>                                                      
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xl={12}>
                                    <Card>
                                        <CardBody>
                                            <CardTitle>Exit Interview Details</CardTitle>
                                                <div className="table-responsive">                                  
                                                    <Row>
                                                        <Col xl={12} sm={12}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Reasons for your departure from Mildmay Uganda
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    What are the reasons for your resignation from Mildmay Uganda? (Please select one or more)
                                                                </p>
                                                                <Row>
                                                                    <Col xl={4}>
                                                                        <div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="higherpay1"
                                                                                checked ={higherpay? true : false}
                                                                                onClick={(e) => {
                                                                                    sethigherpay(!higherpay )
                                                                                }}
                                                                                onChange={() => {
                                                                                    sethigherpay(!higherpay )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="higherpay1"
                                                                                >
                                                                                Higher Pay
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="improvedworklifebalance1"
                                                                                checked ={improvedworklifebalance? true : false}
                                                                                onClick={(e) => {
                                                                                    setimprovedworklifebalance(!improvedworklifebalance )
                                                                                    console.log(improvedworklifebalance)
                                                                                }}
                                                                                onChange={() => {
                                                                                    setimprovedworklifebalance(!improvedworklifebalance )
                                                                                }}
                                                            
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="improvedworklifebalance1"
                                                                                >
                                                                                Improved Work life Balance
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="conflictwithotherstaff1"
                                                                                checked ={conflictwithotherstaff? true : false}
                                                                                onChange={() => {
                                                                                    setconflictwithotherstaff(!conflictwithotherstaff )
                                                                                    console.log(conflictwithotherstaff)
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="conflictwithotherstaff1"
                                                                                >
                                                                                Conflict with Other Staff
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="jobinsecurity1"
                                                                                checked ={jobinsecurity? true : false}
                                                                                onClick={(e) => {
                                                                                    setjobinsecurity(!jobinsecurity )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setjobinsecurity(!jobinsecurity )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="jobinsecurity1"
                                                                                >
                                                                                Job Insecurity
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={4}>
                                                                        <div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="betterbenefits1"
                                                                                checked ={betterbenefits? true : false}
                                                                                onClick={(e) => {
                                                                                    setbetterbenefits(!betterbenefits )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setbetterbenefits(!betterbenefits )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="betterbenefits1"
                                                                                >
                                                                                Better Benefits
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="relocationmigration1"
                                                                                checked ={relocationmigration? true : false}
                                                                                onClick={(e) => {
                                                                                    setrelocationmigration(!relocationmigration )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setrelocationmigration(!relocationmigration )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="relocationmigration1"
                                                                                >
                                                                                Relocation/Migration
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="conflictwithmanagers1"
                                                                                checked ={conflictwithmanagers? true : false}
                                                                                onClick={(e) => {
                                                                                    setconflictwithmanagers(!conflictwithmanagers )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setconflictwithmanagers(!conflictwithmanagers )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="conflictwithmanagers1"
                                                                                >
                                                                                Conflict with Managers
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="furtherstudies1"
                                                                                checked ={furtherstudies? true : false}
                                                                                onClick={(e) => {
                                                                                    setfurtherstudies(!furtherstudies )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setfurtherstudies(!furtherstudies )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="furtherstudies1"
                                                                                >
                                                                                Further Studies
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xl={4}>
                                                                        <div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="bettercareeropportunities1"
                                                                                checked ={bettercareeropportunities? true : false}
                                                                                onClick={(e) => {
                                                                                    setbettercareeropportunities(!bettercareeropportunities )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setbettercareeropportunities(!bettercareeropportunities )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="bettercareeropportunities1"
                                                                                >
                                                                                Better Career Opportunities
                                                                                </label>
                                                                            </div>   
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="closertohome1"
                                                                                checked ={closertohome? true : false}
                                                                                onClick={(e) => {
                                                                                    setclosertohome(!closertohome )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setclosertohome(!closertohome )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="closertohome1"
                                                                                >
                                                                                Closer to Home
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="familypersonalreasons1"
                                                                                checked ={familypersonalreasons? true : false}
                                                                                onClick={(e) => {
                                                                                    setfamilypersonalreasons(!familypersonalreasons )
                                                                                }}
                                                                                onChange={() => {
                                                                                    setfamilypersonalreasons(!familypersonalreasons )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="familypersonalreasons1"
                                                                                >
                                                                                Family/Personal Reasons
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check form-check-primary mb-3">
                                                                                <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="customCheckcolor1"
                                                                                checked={customchkSuccess}
                                                                                onChange={() => {
                                                                                    setcustomchkSuccess(!customchkSuccess )
                                                                                }}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor="customCheckcolor1"
                                                                                >
                                                                                Other(Please specify)
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Col xl={12} sm={12}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Job Improvement Observations
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    In reference to the above, what key observations would you like us to note about your job for improvement?
                                                                </p>
                                                                <Row>
                                                                <div className="form-floating mb-3" >
                                                                <textarea className="form-control" value={jobImprovementObservations} 
                                                                    onChange={(e)=>setjobImprovementObservations(e.target.value)}
                                                                    disabled={(RStatus=='Open')?false:true}
                                                                    rows={1}
                                                                />
                                                                </div>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Col xl={12} sm={12}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Policy & Practice Improvement Observations
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    In reference to the above, what key observations would you like us to take note of for improvement in policy and practice? What other benefits can Mildmay Uganda offer?
                                                                </p>
                                                                <Row>
                                                                <div className="form-floating mb-3" >
                                                                <textarea className="form-control" value={policyImprovementObservations} 
                                                                    onChange={(e)=>setpolicyImprovementObservations(e.target.value)}
                                                                    disabled={(RStatus=='Open')?false:true}
                                                                    rows={1}
                                                                />
                                                                </div>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Col xl={6} sm={6}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Job Dissatisfaction Observations
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    What was least satisfying about your job? What feature/function made your role unpleasant/uncomfortable?
                                                                </p>
                                                                <Row>
                                                                <div className="form-floating mb-3" >
                                                                <textarea className="form-control" value={jobdissatisfaction} 
                                                                    onChange={(e)=>setjobdissatisfaction(e.target.value)}
                                                                    disabled={(RStatus=='Open')?false:true}
                                                                    rows={2}
                                                                />
                                                                </div>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Col xl={6} sm={6}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Potential Return
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    Would you consider coming back to work with Mildmay Uganda in the future? In what area or function?
                                                                </p>
                                                                <Row>
                                                                <div className="form-floating mb-3" >
                                                                <textarea className="form-control" value={potentialreturn} 
                                                                    onChange={(e)=>setpotentialreturn(e.target.value)}
                                                                    disabled={(RStatus=='Open')?false:true}
                                                                    rows={2}
                                                                />
                                                                </div>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Col xl={6} sm={6}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Pleasant Experiences
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    What will you miss most about working at Mildmay Uganda? 
                                                                </p>
                                                                <Row>
                                                                <div className="form-floating mb-3" >
                                                                <textarea className="form-control" value={pleasantexperience} 
                                                                    onChange={(e)=>setpleasantexperience(e.target.value)}
                                                                    disabled={(RStatus=='Open')?false:true}
                                                                    rows={2}
                                                                />
                                                                </div>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Col xl={6} sm={6}>
                                                            <div className="mt-4">
                                                                <h5 className="font-size-14">
                                                                    <i className="mdi mdi-arrow-right text-primary"></i>{" "}
                                                                    Additional Comments
                                                                </h5>
                                                                <p className="sub-header mb-4">
                                                                    Any Additional Comments or details
                                                                </p>
                                                                <Row>
                                                                <div className="form-floating mb-3" >
                                                                <textarea className="form-control" value={additionalComments} 
                                                                    onChange={(e)=>setAdditionalComments(e.target.value)}
                                                                    disabled={(RStatus=='Open')?false:true}
                                                                    rows={2}
                                                                />
                                                                </div>
                                                                </Row>
                                                            </div>
                                                        </Col>

                                                        <Row className='justify-content-center'>
                                                            <Col md={4} className='mb-3'>
                                                                <div className="d-grid gap-2">
                                                                    {(RStatus == 'Open') && (
                                                                    <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleUpdateInterview}>
                                                                        <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                                            Save Exit Interview Details
                                                                    </Button>
                                                                    )}
                                                                </div>      
                                                            </Col>
                                                        </Row>
                                                    </Row>                                   
                                                </div>
                                            </CardBody>
                                        </Card>
                                </Col>
                            </Row> 
                        </div>
                    </Container>
                </div>
            </LoadingOverlay>
        );
    }

export default ExitInterviewDetails;